
/*
Defines the custom element <ravel-progressive-composition-2>
*/

import { RavelProgressiveComposition2 } from './src/RavelProgressiveComposition2.js';

customElements.define('ravel-progressive-composition-2', RavelProgressiveComposition2);
